var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart-wrapper"},[_c('vue-c3',{ref:"line-chart",staticClass:"chart-svg-wrapper",attrs:{"handler":_vm.handler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }